<template>
  <section class="home_campus_job_area">
    <page-header
      title-ch="校園徵才活動"
      title-en="CAMPUS JOB POSTING !"
      variant="second"
      title-divider
    >
      <div class="book first d-none d-sm-block" />
      <div class="book second" />
      <div class="book third" />
      <div class="book fourth d-none d-sm-block" />
    </page-header>
    <div class="container-fluid">
      <div class="row">
        <div class="top_triangle" />
      </div>
      <div class="row">
        <div class="page_content_area container-fluid pt-4">
          <div class="container">
            <campus-recruiting-index-card
              v-for="recruitment in getCampusRecruitments"
              :key="recruitment.recruitment_id"
              :recruitment="recruitment"
            />

            <div class="more_btn_block">
              <router-link
                to="/campus-recruiting"
                class="more_btn"
              >
                更多徵才活動訊息
                <font-awesome-icon icon="sign-out-alt" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="bottom_triangle" />
      </div>
    </div>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import PageHeader from '~components/pages/Header'
import CampusRecruitingIndexCard from '~components/pages/campus-recruiting/common/CampusRecruitingIndexCard'
export default {
  name: 'Jobs',
  components: {
    PageHeader,
    CampusRecruitingIndexCard
  },
  computed: {
    ...mapGetters('pages/home', [
      'getCampusRecruitments'
    ])
  },
  async created () {
    await this.getHomeCampusRecruitingData()
  },
  methods: {
    ...mapActions('pages/home', [
      'getHomeCampusRecruitingData'
    ])
  }
}
</script>
